export const ORDER_QUERY_PARAMS = {
  paymentSuccess: 'payment_success',
  orderId: 'order_id',
} as const;

export const ORDER_TIMEOUTS = {
  pollIntervalMs: 1000, // интервал опроса
  pollMaxTries: 120, // ограничение количества запросов
} as const;

export const isQueryFlagTrue = (sp: URLSearchParams, key: string) =>
  sp.get(key) === '1';
